var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClinic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.88,
    height: 26,
    viewBox: "0 0 28.88 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clinic",
    transform: "translate(0 -9.978)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M27.8,33.813H26.154V16.376a1.082,1.082,0,0,0-1.082-1.082H20.838V11.06a1.082,1.082,0,0,0-1.082-1.082H9.124A1.082,1.082,0,0,0,8.042,11.06v4.233H3.808a1.082,1.082,0,0,0-1.082,1.082V33.813H1.082a1.082,1.082,0,1,0,0,2.165H27.8a1.082,1.082,0,0,0,0-2.165ZM10.207,12.143h8.467V20.61H10.207Zm1.04,21.67V29.245h6.444v4.568Zm6.1-4.568v0Zm2.165,4.568V28.726a1.082,1.082,0,0,0-1.082-1.082H10.453a1.082,1.082,0,0,0-1.082,1.082v5.087H4.891V17.459H8.042v4.233a1.082,1.082,0,0,0,1.082,1.082H19.756a1.082,1.082,0,0,0,1.082-1.082V17.459h3.151V33.813h-4.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M77.7,34.807h1.01v1.01a.917.917,0,0,0,1.834,0v-1.01h1.01a.917.917,0,1,0,0-1.834h-1.01v-1.01a.917.917,0,1,0-1.834,0v1.01H77.7a.917.917,0,1,0,0,1.834Z",
    transform: "translate(-65.191 -17.514)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClinic);
export default __webpack_public_path__ + "static/media/icon_clinic.652445955a2e3dedf18ff1a2fe066e34.svg";
export { ForwardRef as ReactComponent };